export const BLANK_TYPE = 'blank';



export const MARK_ITEM = 'mark_item';

export const HEADING = 'HEADING';

export const HEADING_ONE = 'HEADING_ONE';

export interface BlankItem {
  key: number; // index blank in this question
  id: string;
  userAnswer?: string;
  userAnswerIdx?: number;
  correctAnswer?: string;
  markedType?: any;
}

export interface BlankItemResult extends BlankItem {
  no: number; // question no in test
}
